import api from '@/services'

export function fetchDashboardAluno(){
  return api.get('/dashboardAluno')
}

export function gerarBoleto(ano, mes){
  return api.get(`/dashboardAluno/boleto/${ano}/${mes}`)
}